import ProfileRouter from './Profile.router';
export default ProfileRouter;

export { default as profileRouterRoutes } from './routes';
